export default "__VITE_ASSET__DZAngH$K__"